import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { fontSize, lineHeight, space, width } from 'styled-system';

import { Button } from 'common/components/Button';

const UnstyledBaseCTAButton = styled(Button)<any>`
  ${width};
  ${space};
  ${fontSize};
  ${lineHeight};
`;

const BaseCTAButton = (props: ComponentProps<typeof UnstyledBaseCTAButton>) => (
  <UnstyledBaseCTAButton
    width={[1, '360px', 'fit-content']}
    py="sp_12"
    px="sp_16"
    fontSize="fs_18"
    lineHeight="lh_24"
    {...props}
  />
);

export default BaseCTAButton;
